import { useState } from 'react';
import { gt } from 'semver';
import { useChangelogVersion } from './useChangelogVersion';

export const useChangelogVisibilityOptions = ({ initialOpened }: { initialOpened?: boolean } = {}) => {
  const { latestChangelogVersion, storedVersion } = useChangelogVersion();
  return useState(initialOpened ?? Boolean(storedVersion && gt(latestChangelogVersion, storedVersion)));
};
